import React, { useEffect, useState } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import styles from './Bill.module.css';
import { IoMdShare } from "react-icons/io";
import { useParams } from 'react-router';
import { BASE_URL_API } from '../References/url';
import LoadingScreen from './LoadingScreen';
import OfferTemplateA from '../Components/OfferTemplateA';
import OfferTemplateB from '../Components/OfferTemplateB';
import OfferTemplateC from '../Components/OfferTemplateC';
import OfferTemplateD from '../Components/OfferTemplateD';


const pdfSizes = {
    A4: { width: 210, height: 297 },
    Letter: { width: 216, height: 279 },
};



const Bill = () => {
    const [pdfSize] = useState("A4"); // Default to A4
    const [isLoading, setIsLoading] = useState(true)
    const [status, setStatus] = useState('')
    const [isValid, setIsValid] = useState(false)
    const { invoiceKey } = useParams()
    const [invoiceData, setInvoiceData] = useState({
        invoiceNumber: "INV-S-2025-03-18-000000001",
        invoiceDate: "2025-03-18",
        dueDate: "2025-03-18",
        remainingAmount: 190,
        clientData: {
            clientName: "NAVNEET CHANDAN",
            mobile: "9999648406",
            billingAddress: "",
        },
        productData: [
            { productTitle: "REGULAR HAIRCUT (MEN)", qty: 1, price: 180, discount: 30, total: 150 },
            { productTitle: "BEARD TRIMMING", qty: 1, price: 120, discount: 0, total: 120 },
            { productTitle: "BEARD TRIMMING", qty: 1, price: 120, discount: 0, total: 120 },
            { productTitle: "BEARD TRIMMING", qty: 1, price: 120, discount: 0, total: 120 },
            { productTitle: "BEARD TRIMMING", qty: 1, price: 120, discount: 0, total: 120 },
            { productTitle: "BEARD TRIMMING", qty: 1, price: 120, discount: 0, total: 120 },
        ],
        logo: "https://sm.lokaci.com/assets/clients/logos/sky-salon.jpeg"
    })

    const getInvoiceData = async () => {
        setIsLoading(true)
        const getInvoiceDataResponse = await fetch(BASE_URL_API + "getInvoiceData",
            {
                method: "POST",
                body: JSON.stringify({
                    invoiceKey: invoiceKey
                })
            });

        if (!getInvoiceDataResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getInvoiceDataRespo = await getInvoiceDataResponse.json()
            if (getInvoiceDataRespo.status === "success") {
                setIsValid(true)
                setInvoiceData(getInvoiceDataRespo?.response)
            } else {
                setIsValid(false)
            }
            console.log(getInvoiceDataRespo)
        }
        setIsLoading(false)
    }


    useEffect(() => {
        getInvoiceData()
    }, [invoiceKey])

    const getStatus = (remainingAmount) => {
        if (remainingAmount === null || remainingAmount === undefined || remainingAmount === "" || isNaN(remainingAmount)) {
            return "Invalid Amount";
        }

        const amount = Number(remainingAmount); // Convert to number

        if (amount < 0) return "Overpaid";
        if (amount === 0) return "Paid";
        if (amount > 0 && amount < 100) return "Partially Paid";

        return "Pending";
    };


    useEffect(() => {
        setStatus(getStatus(invoiceData.remainingAmount))
    }, [invoiceData])


    const generatePDF = async () => {
        const invoiceElement = document.getElementById("invoicePreview");
        const size = pdfSizes[pdfSize];

        if (!invoiceElement) {
            console.error("Invoice element not found!");
            return;
        }

        const canvas = await html2canvas(invoiceElement, {
            scale: 2,
            useCORS: true,
            onclone: (clonedDocument) => {
                const logoImage = clonedDocument.getElementById("logo");
                if (logoImage) {
                    logoImage.crossOrigin = "anonymous";
                }
            },
        });

        const imageData = canvas.toDataURL("image/png");
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;

        const aspectRatio = contentWidth / contentHeight;
        let pdfWidth = size.width;
        let pdfHeight = pdfWidth / aspectRatio;

        if (pdfHeight > size.height) {
            pdfHeight = size.height;
            pdfWidth = pdfHeight * aspectRatio;
        }

        const pdf = new jsPDF("portrait", "mm", [size.width, size.height]);
        const xOffset = (size.width - pdfWidth) / 2;
        const yOffset = 0;

        pdf.addImage(imageData, "PNG", xOffset, yOffset, pdfWidth, pdfHeight);
        pdf.save("Invoice.pdf");
    };

    const convertImageToBase64 = async (imageUrl) => {
        try {
            const proxyUrl = `https://bill.lokaci.com/cors-proxy.php?url=${encodeURIComponent(imageUrl)}`;
            console.log("Fetching from:", proxyUrl);

            const response = await fetch(proxyUrl);

            if (!response.ok) {
                throw new Error(`HTTP Error! Status: ${response.status}`);
            }

            const blob = await response.blob();

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = () => reject("Failed to convert image.");
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image to base64:", error);
            return null;
        }
    };


    const getProductItemsTotal = (key) => {
        // Validate the input parameters
        if (!key || typeof key !== "string") {
            console.error("Invalid key parameter. Please provide a valid string key.");
            return 0;
        }
        if (!Array.isArray(invoiceData?.productData)) {
            console.error("Invalid data parameter. Please provide an array of objects.");
            return 0;
        }

        // Calculate the total
        return invoiceData?.productData.reduce((total, item) => {
            const value = Number(item[key]);
            if (typeof value === "number" && !isNaN(value)) {
                return total + value;
            }
            return total; // Ignore non-numeric or missing values
        }, 0);
    }


    if (isLoading) {
        return (
            <LoadingScreen />
        )
    }

    if (!isValid) {
        return (
            <div>
                Invalid Invoice
            </div>
        )
    }

    return (
        <div className={styles.billContainer}>
            <div id="invoicePreview" className={styles.invoiceContentWrapper}>
                <div className={styles.businessHeaderWrapper}>
                    <div className={styles.businessName}>
                        {invoiceData?.storeData?.storeName}
                    </div>
                    <div className={styles.businessAddress}>
                        {invoiceData?.storeData?.storeAddress}
                    </div>
                    <div className={styles.businessPhone}>
                        +91-{invoiceData?.storeData?.storePhone}
                    </div>
                    {invoiceData?.isGstBill &&
                        <div className={styles.gstMetaDataWrapper}>
                            <div className={styles.gstNumber}>
                                GSTIN : {invoiceData?.gstMetaData?.gstNumber}
                            </div>
                            <div className={styles.legalName}>
                                {invoiceData?.gstMetaData?.legalName}
                            </div>
                            {/* <div className={styles.businessAddress}>
                                {invoiceData?.gstMetaData?.businessAddress}
                            </div> */}
                        </div>
                    }
                </div>


                <div className={styles.invoiceNumberWrapper}>
                    <div className={styles.headerTitle} >Invoice Number:</div>
                    <div className={styles.headerValue} >{invoiceData.invoiceNumber}</div>
                </div>

                <div className={styles.upperHeaderWrapper}>
                    <div className={styles.headersWrapper}>
                        <div className={styles.eachHeaderWrapper}>
                            <div className={styles.headerTitle} >Invoice Date:</div>
                            <div className={styles.headerValue} >{invoiceData.invoiceDate}</div>
                        </div>
                        <div className={styles.eachHeaderWrapper}>
                            <div className={styles.headerTitle} >Due Date:</div>
                            <div className={styles.headerValue} >{invoiceData.dueDate}</div>
                        </div>
                        <div className={styles.eachHeaderWrapper}>
                            <div className={styles.headerTitle} >Bill To:</div>
                            <div className={styles.headerValue} >{invoiceData.clientData?.clientName}</div>
                        </div>
                        <div className={styles.eachHeaderWrapper}>
                            <div className={styles.headerTitle} >Mobile:</div>
                            <div className={styles.headerValue} >{invoiceData.clientData?.mobile}</div>
                        </div>
                    </div>
                    <div className={styles.logoWrapper}>
                        {invoiceData?.storeData?.storeLogo ? <img src={invoiceData?.storeData?.storeLogo} alt="Logo" />
                            :
                            <div className={styles.customLogoWrapper}>
                                <div className={styles.customLogoContainer}>
                                    {invoiceData?.storeData?.storeName?.substring(0, 1)}
                                </div>
                            </div>
                        }
                    </div>
                </div>



                <table className={styles.table}>
                    <thead className={styles.thead}>
                        <tr>
                            <th>Service</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Off{invoiceData?.discountType === "value" ? `(₹)` : `(%)`} </th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody className={styles.tbody}>
                        {invoiceData.productData.map((item, index) => (
                            <tr key={index}>
                                <td className={styles.productTitle}>{item.productTitle}</td>
                                <td>{item.qty}</td>
                                <td>{item.price}</td>
                                <td>{item.discount}</td>
                                <td>{item.total}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {invoiceData?.isGstBill &&
                    <div className={styles.taxDataWrapper}>
                        <div className={styles.taxableValue}>
                            <div>Taxable Value</div>
                            <div>₹{((getProductItemsTotal("total") || 0) / 1.05).toFixed(2)}</div>
                        </div>
                        <div className={styles.totalTax}>
                            <div>Total Tax (5%)</div>
                            <div>+₹{((getProductItemsTotal("total") || 0) - ((getProductItemsTotal("total") || 0) / 1.05)).toFixed(2)}</div>
                        </div>
                    </div>
                }

                <div className={styles.totalWrapper}>
                    <div>
                        Total
                    </div>
                    <div>
                        ₹{getProductItemsTotal("total")}
                    </div>
                </div>
                <div className={styles.paidViaWrapper}>
                    <div className={styles.paidViaContainer}>
                        {invoiceData?.collectionData?.map((itemCollection, indexCollection) => (
                            <div className={styles.eachModeWrapper} key={indexCollection}>
                                <div>
                                    {itemCollection?.mode?.replace("collectionVia", "Via ")}
                                </div>
                                <div>
                                    ₹{itemCollection?.amount}
                                </div>
                            </div>
                        ))}
                        {invoiceData?.remainingAmount > 0 &&
                            <div className={`${styles.eachModeWrapper} ${styles.outStandingPayment}`}>
                                <div>
                                    Outstanding Payment
                                </div>
                                <div>
                                    ₹{invoiceData?.remainingAmount}
                                </div>
                            </div>
                        }
                    </div>

                </div>

                <div className={styles.thankYouNote}>
                    Thank you for your purchase at {invoiceData?.storeData?.storeName}!
                </div>

                <div className={styles.watermark}>
                    <div className={`${styles.statusStamp} ${status === "Paid" ? styles.statusPaid : status === "Partially Paid" ? styles.statusPartial : styles.statusPending}`}>
                        {status}
                    </div>
                </div>

                {invoiceData?.storeData?.storeIdentifier === "201758215315004432" &&
                    <>
                        {/* <OfferTemplateA invoiceData={invoiceData} getProductItemsTotal={getProductItemsTotal} /> */}
                        <OfferTemplateB invoiceData={invoiceData} getProductItemsTotal={getProductItemsTotal} />
                        {/* <OfferTemplateC invoiceData={invoiceData} getProductItemsTotal={getProductItemsTotal} /> */}
                        {/* <OfferTemplateD invoiceData={invoiceData} getProductItemsTotal={getProductItemsTotal} /> */}
                    </>
                }
            </div>
            <div className={styles.footer}>
                <div className={styles.footerContainer}>
                    <button className={styles.shareBtn}> <IoMdShare size={24} /></button>
                    <button onClick={generatePDF} className={styles.downloadBtn}>Download PDF</button>
                </div>
            </div>
        </div>
    );
};

export default Bill;
